export const FAQ = {
  faq_view_title: "FAQ Management",
  faq_add_title: "Add FAQ",
  faq_edit_title: "Edit FAQ",
  faq_view_question: "Question",
  faq_view_answer: "Answer",
  faq_view_last_update: "Last Update",
  faq_view_line_of_business: "Line of Business",
  faq_view_top_bar_search: "Search",
  faq_add_line_of_business: "Line of Business",
  faq_add_takaful_providers: "Takaful Providers",
  faq_add_line_of_business_err: "Line of business is required field",
  faq_add_question: "Question",
  faq_add_question_err: "Question is required field",
  faq_add_question_err_max_length: "Question can't be more then 255 characters",
  faq_add_answer: "Answer",
  faq_add_answer_err: "Answer is required field",
  faq_add_answer_err_max_length: "Answer can't be more then 1000 characters"
};
